export const getDefaultColumnFilterPredicate = (column, defaultColumnFilter) => {
    return typeof defaultColumnFilter === 'function'
        ? defaultColumnFilter(column)
        : defaultColumnFilter;
};
